import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from '../store';

type GlobalDateState = {
  // true while the currently displayed view loads its data without date consideration,
  // which means the globally selected date has no effect on what the user sees
  isIgnoredByCurrentView: boolean;
};

const initialState: GlobalDateState = {
  isIgnoredByCurrentView: false,
};

const globalDateSlice = createSlice({
  name: 'globalDate',
  initialState,
  reducers: {
    setIsIgnoredByCurrentView(state, action: PayloadAction<boolean>) {
      state.isIgnoredByCurrentView = action.payload;
    },
  },
});

export default globalDateSlice.reducer;

// Has to be reset by the view that set it as soon as it unmounts, otherwise the header
// would keep indicating that the global date is not applied.
export const setGlobalDateIgnoredByCurrentView = (value: boolean) => {
  dispatch(globalDateSlice.actions.setIsIgnoredByCurrentView(value));
};
